import _u from './utility';
import _v from './vars';
import _fn from './main-fn';

const init = function() {

	// Init AppMeasurement and pass into local/global vars
	if (_v['s_ver'].indexOf('prof') == -1) { // If Adobe Plugins in JS
		window.s_md = s_gi(_v.g['s_account']);
	} else {
		window.s_md = window.s;
	}
	_v.g['s_md'] = s_md;
	
	let visitorConfig = {
		trackingServer:"std.o." + _v.g['s_cname'],
		trackingServerSecure:"ssl.o." + _v.g['s_cname'],
		marketingCloudServer:"std.o." + _v.g['s_cname'],
		marketingCloudServerSecure:"ssl.o." + _v.g['s_cname']
	};
	
	if ((document.getElementById('ot-stub') != null && userInEU && document.cookie.match(/OptanonConsent[^;]+&groups/) == null) || document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0002%3A0/) != null || document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0003%3A0/) != null || document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0004%3A0/) != null) {
		Object.assign(visitorConfig, {			
			disableThirdPartyCalls: true,
			disableThirdPartyCookies: true,
			disableIdSyncs: true
		});
    }
	
	/* Setup VisitorAPI */
	s_md.visitor = Visitor.getInstance("16AD4362526701720A490D45@AdobeOrg", visitorConfig);

	var authLevel = "";
	var regId = "";
	if (typeof PageMetadata !== 'undefined' && typeof PageMetadata.authVar !== 'undefined') {
		authLevel = PageMetadata.authVar.authLevel;
	}
	else if (typeof s_auth_channel_id !== 'undefined') {
		authLevel = _fn.getAuthLevel(s_auth_channel_id);
	}

	if (typeof s_registered_user_id !== 'undefined') {
		regId = s_registered_user_id;
	}
	else if (typeof PageMetadata !== 'undefined' && typeof PageMetadata.userSegVars !== 'undefined' && typeof PageMetadata.userSegVars.gd !== 'undefined') {
			regId = PageMetadata.userSegVars.gd;
	}

	if (_v['s_ver'].indexOf('prof') == -1) { // If Adobe Plugins in JS
		//PPE-311863 = Pass customer id to adobe audience manager
		if (_v['s_ver'].indexOf('medscape') !== -1) {
			s_md.visitor.setCustomerIDs({
				"medscapeguid": {
					"id": regId,
					"authState": Number(authLevel)
				}
			});
		}
		window.visitor = s_md.visitor; // Leaving global var 'visitor' for ads code dependency
		document.dispatchEvent(new CustomEvent('visitorIdSet'));
	}

	s_md.visitor.loadTimeout = 30000;

	/* Instantiate AAM */
	if (_v['s_ver'].indexOf('prof') == -1) { // If Adobe Plugins in JS
		s_md.loadModule("AudienceManagement");
	}


	/* Set-up the AppMeasurment tracking servers */
	s_md.trackingServer="std.o." + _v.g['s_cname'];
	s_md.trackingServerSecure="ssl.o." + _v.g['s_cname'];
	s_md.dc="122";

	/* Config Section */
	s_md.cookieDomainPeriods = "3";
	s_md.jsCookieDomainPeriods = "2";
	s_md.charSet = "UTF-8";
	s_md.currencyCode = "USD";
	s_md.trackDownloadLinks = false;
	s_md.trackExternalLinks = false;
	s_md.trackInlineStats = true;
	s_md.linkDownloadFileTypes = "exe,zip,wav,mp3,mov,mpg,avi,wmv,doc,pdf,xls";
	s_md.linkInternalFilters = "javascript:,." + _v.main_domain_name + ".com,." + _v.main_domain_name + ".org,." + _v['s_domain'];
	s_md.linkLeaveQueryString = false;
	s_md.linkTrackEvents = "None";
	s_md.visitorNamespace = "webmd";
	s_md.usePlugins = true;
	
	s_md.linkTrackVars = _v.g['s_linkTrackVars'];
	s_md.server = _v['s_ver'].toLowerCase();
	s_md.pageName = _v.g['s_pagename'];
	s_md.pageURL = _v.g['s_pageurl'];
	//PPE-PPE-386424
	s_md.eVar1 = "D=pageName";
		
	s_md.registerPostTrackCallback(_fn.tCb); // Callback function fired right after tracking call
	
	s_md.doPlugins = function(s) { // Adobe callback function fired right before initial pageView
		if (document.getElementById('ot-stub') == null || (document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0002%3A1/) != null && document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0003%3A1/) != null && document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0004%3A1/) != null) || (document.getElementById('ot-ccpa') != null && document.cookie.match(/OptanonConsent[^;]+&groups/) == null)) {
			if (typeof AppMeasurement_Module_AudienceManagement === 'function' && _v['s_ver'].indexOf('prof') == -1) {
				s_md.AudienceManagement.setup({
					'partner': 'webmd',
					'containerNSID': 0,
					'uuidCookie': {
						'name': 'aam_uuid',
						'days': 30
					},
					'visitorService': {
						'namespace': '16AD4362526701720A490D45@AdobeOrg'
					}
				});
			}
		}

		if (_v['s_ver'].indexOf('prof') !== -1) { // If Adobe Plugins in JS
			//PPE-311863 = Pass customer id to adobe audience manager
			if (_v['s_ver'].indexOf('medscape') !== -1) {
				s_md.visitor.setCustomerIDs({
					"medscapeguid": {
						"id": regId,
						"authState": Number(authLevel)
					}
				});
			}
			window.visitor = s_md.visitor; // Leaving global var 'visitor' for ads code dependency
			document.dispatchEvent(new CustomEvent('visitorIdSet'));
		}
		
	}
	
	/* Google AdSense Tracking */
	s_md.c_gd = new Function("" + "var s=this,d=s.wd.location.hostname,n=s.jsCookieDomainPeriods,n2=s." + "cookieDomainPeriods,p;if(d&&!s.c_d){n=n?n:n2;n=n?parseInt(n):2;n=n>" + "2?n:2;p=d.lastIndexOf('.');while(p>=0&&n>1){p=d.lastIndexOf('.',p-1" + ");n--}s.c_d=p>0&&s.pt(d,'.','c_gdf',0)?d.substring(p):'';}return s." + "c_d");
	s_md.trackGAS = new Function("" + "var s_md=this,gifa=document.getElementsByTagName('iframe'),gif;for(v" + "ar i=0;i<gifa.length;i++){if(gifa[i].src.indexOf('googlesyndication." + "com')>-1){gif=gifa[i];if(gif.attachEvent){gif.attachEvent('onfocus'," + "s_md.gasf);}}}");	
	if (_v['s_ver'].indexOf('prof') == -1) { // If Adobe Plugins in JS
		s_md.gasf = new Function("" + "var s_md=s_gi(s_account);s.tl(true,'o','Go" + "ogle Exit Link');");
	} else {
		s_md.gasf = new Function("" + "var s_md=s;s.tl(true,'o','Go" + "ogle Exit Link');");
	}
	
	s_md.trackGAS();

	//PPE-311863 = Pass customer id to adobe audience manager
	if (document.getElementById('ot-stub') == null || (document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0002%3A1/) != null && document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0003%3A1/) != null && document.cookie.match(/OptanonConsent[^;]+&groups[^;]+C0004%3A1/) != null) || (document.getElementById('ot-ccpa') != null && document.cookie.match(/OptanonConsent[^;]+&groups/) == null)) {
		var vDil = DIL.create({
			partner: "webmd",
			visitorService:{
				namespace:"16AD4362526701720A490D45@AdobeOrg"
			}
		});
	}

	_v['isInitialized'] = true;
	window.beaconInitialized = _v['isInitialized'];
	document.dispatchEvent(new CustomEvent('beaconInitialized'));

}

export default init;
